// removed by extract-text-webpack-plugin
module.exports = {"new-email-input-row":"newEmail__new-email-input-row___V0eXA","new-email-panel-content":"newEmail__new-email-panel-content___2tWwd","new-email-folder-information":"newEmail__new-email-folder-information___3r30J","new-email-input":"newEmail__new-email-input___375jy","btn-cancle":"newEmail__btn-cancle___3xtUX","hint-msg":"newEmail__hint-msg___yTC6D"};


//////////////////
// WEBPACK FOOTER
// ./src/views/email/newEmail/newEmail.less
// module id = 544
// module chunks = 3